import * as React from "react";
import { observer } from "mobx-react-lite";
import Loader from "@asphalt-react/loader";
import { ReactSVG } from "react-svg";
import styled from "styled-components";
import { useFilePickerState } from "../../states";
import { useTranslation } from "src/hooks";
import { FilePickerOnDrag } from "./OnDrag.component";
import { FilePickerImagePreview, FilePickerError } from "../../components";
import { Button, Box } from "src/components";
import { Text } from "src/components/Text";

const HelperTextEl = styled(Text)`
  color: rgba(31, 36, 42, 0.5);
  line-height: 14px;
`;

export type IFilePickerContentProps = {
  getErrorTranslation?: (error: string) => string;
};

export const FilePickerContent: React.FC<IFilePickerContentProps> = observer(
  (props) => {
    const translate = useTranslation();
    const state = useFilePickerState();
    const {
      error,
      helperText,
      isDragActive,
      isLoading,
      maxSize,
      previewUrl,
      buttonText,
    } = state;
    const { getErrorTranslation } = props;

    const buttonCta = buttonText || translate("upload_file");

    if (isDragActive) {
      return <FilePickerOnDrag />;
    }

    if (error) {
      return <FilePickerError getTranslation={getErrorTranslation} />;
    }

    if (previewUrl && !isLoading) {
      return <FilePickerImagePreview />;
    }

    return (
      <>
        {isLoading ? (
          <Box marginBottomXl>
            <Loader size="l" />
          </Box>
        ) : (
          <>
            <ReactSVG
              src={require("../assets/images/upload-placeholder.svg")}
            />
            <Text fontWeight="book" fontSize="medium" color="accent">
              {translate("drag_and_drop")}
            </Text>
          </>
        )}
        <Box paddingRightXl paddingLeftXl width100>
          <Button
            width100
            marginTopXl
            marginBottomXl
            id="asp-file-picker-upload"
            onClick={() => state.inputRef?.current?.click()}
          >
            {isLoading ? translate("uploading") : buttonCta}
          </Button>
        </Box>
        <HelperTextEl
          id="asp-file-picker-helper-text"
          fontWeight="demi"
          fontSize="xsmall"
        >
          {helperText ?? translate("default_helper_text", [`${maxSize}MB`])}
        </HelperTextEl>
      </>
    );
  }
);
